/* ADD Knowledge categories */
export const ADD_COURSE_KNOWLEDGE = "ADD_COURSE_KNOWLEDGE"
export const ADD_COURSE_KNOWLEDGE_SUCCESS = "ADD_COURSE_KNOWLEDGE_SUCCESS"
export const ADD_COURSE_KNOWLEDGE_CLEAN = "ADD_COURSE_KNOWLEDGE_CLEAN"
export const ADD_COURSE_KNOWLEDGE_ERROR = "ADD_COURSE_KNOWLEDGE_ERROR"
